import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { addFTPConfig, addFTPExportBatch, addFTPImportBatch, getFTPConfigById, getFTPConfigList, getFTPExportBatchById, getFTPExportBatchList, getFTPImportBatchById, getFTPImportBatchesList, updateFTPConfig, updateFTPExportBatch, updateFTPImportBatch } from "./FTPImportBatchesRepo";
import { showToast } from "../../../utils/toastUtils";

// getFTPImportBatchesList
export const useFTPImportBatches = ({
  enable = false,
  params,
}: {
  enable: boolean;
  params?: any;
}) => {
  return useQuery({
    queryKey: ["GET_FTP_IMPORT_BATCHES", params],
    queryFn: () => getFTPImportBatchesList(params),
    retry: false,
    enabled: enable,
  });
};

export const useAddFTPImportBatches = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (reqBody: any) => addFTPImportBatch(reqBody),

    onSuccess: (response) => {
       showToast.success(response.message);
      queryClient.invalidateQueries({ queryKey: ["GET_FTP_IMPORT_BATCHES"] });
    },
    onError: (error: any) => {
      showToast.error( error.message);
    },
  });
};

export const useFTPImportBatchesById = ({
  enable = false,
  params,
}: {
  enable: boolean;
  params?: any;
}) => {
  return useQuery({
    queryKey: ["GET_FTP_IMPORT_BATCHES_BY_ID", params],
    queryFn: () => getFTPImportBatchById(params),
    retry: false,
    enabled: enable,
  });
}


export const useUpdateFTPImportBatches = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (reqBody: any) => updateFTPImportBatch(reqBody),

    onSuccess: (response) => {
       showToast.success(response.message);
      queryClient.invalidateQueries({ queryKey: ["GET_FTP_IMPORT_BATCHES"] });
      queryClient.invalidateQueries({ queryKey: ["GET_FTP_IMPORT_BATCHES_BY_ID"] });
    },
    onError: (error: any) => {
      showToast.error( error.message);
    },
  });
};


export const useFTPConfigList = ({
  enable = false,
  params,
}: {
  enable: boolean;
  params?: any;
}) => {
  return useQuery({
    queryKey: ["GET_FTP_CONFIG_LIST", params],
    queryFn: () => getFTPConfigList(params),
    retry: false,
    enabled: enable,
  });
}

export const useFTPConfigById = ({
  enable = false,
  params,
}: {
  enable: boolean;
  params?: any;
}) => {
  return useQuery({
    queryKey: ["GET_FTP_CONFIG_BY_ID", params],
    queryFn: () => getFTPConfigById(params),
    retry: false,
    enabled: enable,
  });
}

export const useAddFTPConfig = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (reqBody: any) => addFTPConfig(reqBody),

    onSuccess: (response) => {
       showToast.success(response.message);
      queryClient.invalidateQueries({ queryKey: ["GET_FTP_CONFIG_LIST"] });
      queryClient.invalidateQueries({ queryKey: ["GET_FTP_CONFIG_BY_ID"] });
    },
    onError: (error: any) => {
      showToast.error( error.message);
    },
  });
};

export const useUpdateFTPConfig = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (reqBody: any) => updateFTPConfig(reqBody),

    onSuccess: (response) => {
       showToast.success(response.message);
      queryClient.invalidateQueries({ queryKey: ["GET_FTP_CONFIG_LIST"] });
      queryClient.invalidateQueries({ queryKey: ["GET_FTP_CONFIG_BY_ID"] });
    },
    onError: (error: any) => {
      showToast.error( error.message);
    },
  });
};


export const useFTPExportBatchList = ({
  enable = false,
  params,
}: {
  enable: boolean;
  params?: any;
}) => {
  return useQuery({
    queryKey: ["GET_FTP_EXPORT_BATCH_LIST", params],
    queryFn: () => getFTPExportBatchList(params),
    retry: false,
    enabled: enable,
  });
}

export const useFTPExportBatchById = ({
  enable = false,
  params,
}: {
  enable: boolean;
  params?: any;
}) => {
  return useQuery({
    queryKey: ["GET_FTP_EXPORT_BATCH_BY_ID", params],
    queryFn: () => getFTPExportBatchById(params),
    retry: false,
    enabled: enable,
  });
}

export const useAddFTPExportBatch = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (reqBody: any) => addFTPExportBatch(reqBody),

    onSuccess: (response) => {
       showToast.success(response.message);
      queryClient.invalidateQueries({ queryKey: ["GET_FTP_EXPORT_BATCH_LIST"] });
      queryClient.invalidateQueries({ queryKey: ["GET_FTP_EXPORT_BATCH_BY_ID"] });
    },
    onError: (error: any) => {
      showToast.error( error.message);
    },
  });
};

export const useUpdateFTPExportBatch = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (reqBody: any) => updateFTPExportBatch(reqBody),

    onSuccess: (response) => {
       showToast.success(response.message);
      queryClient.invalidateQueries({ queryKey: ["GET_FTP_EXPORT_BATCH_LIST"] });
      queryClient.invalidateQueries({ queryKey: ["GET_FTP_EXPORT_BATCH_BY_ID"] });
    },
    onError: (error: any) => {
      showToast.error( error.message);
    },
  });
};
